import { useState } from 'react'
import { HiddenMenu, Menu, DropIcon } from 'components'
import Text from 'components/priority/Text/Text'
import * as S from './Dropdown.styled'
import determineDropdown from 'utils/global/determineDropdown'
import { useTranslation } from 'react-i18next'

export const Dropdown = ({
  width,
  full,
  margin,
  label,
  color,
  selected: [selected, setSelected] = ['', null],
  placeholder,
  items,
  valueKey,
  textKey,
  fontMenu,
  useKeyAsValue,
  disabled,
  children,
  customLayout,
  ...props
}) => {
  const [menuOpen, setMenuOpen] = useState()
  const { t } = useTranslation()
  const dropdown = determineDropdown(
    items,
    valueKey,
    textKey,
    useKeyAsValue,
    selected,
    setSelected,
    customLayout,
    t,
  )

  return (
    <>
      <HiddenMenu
        full
        width={width}
        show={[menuOpen, setMenuOpen]}
        margin={margin}
        parentElement={() => (
          <S.DropdownWrapper column disabled={disabled}>
            {label && (
              <Text color={color} size="12px" margin="0 0 4px 0" weight="500">
                {label}
              </Text>
            )}
            <S.Dropdown
              full={full}
              clickable
              padding="12px 16px"
              height="42px"
              minWidth="200px"
              justify="space-between"
              align="center"
              onClick={() => items && setMenuOpen(!menuOpen)}
              {...props}
            >
              <S.DropdownText full={full} whiteSpace="nowrap" width="100%">
                {selected && dropdown?.selectText
                  ? dropdown.selectText
                  : placeholder}
              </S.DropdownText>
              <DropIcon margin="0 0 0 8px" up={menuOpen} />
            </S.Dropdown>
          </S.DropdownWrapper>
        )}
        hiddenElement={() => (
          <Menu
            fontMenu={fontMenu}
            full={full}
            items={dropdown?.items}
            show={[menuOpen, setMenuOpen]}
          >
            {children}
          </Menu>
        )}
      />
    </>
  )
}

export default Dropdown
